export const removeSpaces = (phone: string) => {
  return phone.split(' ').join('')
}
